import React from 'react';
import "./Footer.scss";

const Footer = () => {
  return (
    <div className='footer-container'>
      <p className="footer__copyright">@2023 engLingo. All rights reserved</p>
    </div>
  )
}

export default Footer